module.exports = function () {
    const btn = document.querySelector('.scroll-down-btn');

    if (typeof (btn) != 'undefined' && btn != null) {
        btn.addEventListener("click", scrollToNextSection, false);
    }


    function scrollToNextSection() {
        const parent = btn.closest('section').nextElementSibling.offsetTop;
        scroll({
            top: parent,
            behavior: "smooth"
        });
    }
}